import { useTranslation } from 'react-i18next';

import { useAppContext } from '../../../../app/Context';
import { i18nNS } from '../../../../i18n';
import { FormValues as IntroductionFormValues } from '../../../shared/TileIntroductionForm/types';
import { setTimerSkipIntroduction } from '../../../../db/timer';
import { useCallback } from 'react';
import { SlideType } from '../../../../db/shared/types';
import { setActivityType } from '../../../../db/shared';
import routes from '../../../../routes/router';

export interface UseTimerSteps {
  goToNextStep: () => void;
}

const useTimerSteps = ({ goToNextStep }: UseTimerSteps) => {
  const { t } = useTranslation([i18nNS.COMMON, i18nNS.TIMER]);

  const { presentationId, activeSlideId, setSlideTitleAndSubtitle } = useAppContext();

  const handleGoToTimer = useCallback(() => {
    if (!presentationId) return;
    if (!activeSlideId) return;

    setSlideTitleAndSubtitle({
      title: t('acadly_activity_plugin', {
        ns: i18nNS.COMMON,
      }),
      subtitle: t('timer_was_not_started', { ns: i18nNS.TIMER }),
    });

    setActivityType(presentationId, activeSlideId, SlideType.TIMER, routes.timer.url());

    goToNextStep();
  }, [presentationId, activeSlideId, setSlideTitleAndSubtitle, goToNextStep]);

  const handleClickIntroductionNext = (data: IntroductionFormValues) => {
    setTimerSkipIntroduction(data.doNotShowAgain);
    handleGoToTimer();
  };

  return {
    handleClickIntroductionNext,
    handleGoToTimer,
  };
};

export default useTimerSteps;
